export const GET_LOCAL_DATA = "GET_LOCAL_DATA"
export const GET_LOCAL_DATA_SUCCESS = "GET_LOCAL_DATA_SUCCESS"
export const GET_LOCAL_DATA_FAIL = "GET_LOCAL_DATA_FAIL"

